import * as _ from 'lodash';
import { ImCourseDiff } from 'Src/ng2/shared/services/im-models/im-course-diff';
import { ImGapPlan } from 'Src/ng2/shared/services/im-models/im-gap-plan';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';
import { ICourseDiff, ICourseDiffPartial } from '../../../../../../ng2/shared/typings/interfaces/course-diff.interface';
import { IGapPlan, IGapPlanPartial } from '../../../../../../ng2/shared/typings/interfaces/gap-plan.interface';
import { ICourse, ISchool } from '../../../../../../ng2/shared/typings/interfaces/school.interface';
import {
  ICurrProgramCourse,
  ICurrProgramCoursePartial,
  IStudent,
} from '../../../../../../ng2/shared/typings/interfaces/student.interface';
import { CreditGapCoursePickerModal } from '../../../../../shared/modals/credit-gap-course-picker/credit-gap-course-picker-modal.service';
import { CreditGapFreeformCourseModal } from '../../../../../shared/modals/credit-gap-freeform/credit-gap-freeform-course-modal.service';
import { ImStudentCreditGaps } from '../../../../../shared/static-models/im-models/im-student-credit-gaps';
import {
  ICourseWarnings,
  ImStudentCurrentProgram,
} from '../../../../../shared/static-models/im-models/im-student-current-program';
import { ImStudentCurrentProgramHelpers } from '../../../../../shared/static-models/im-models/im-student-current-program-helpers';

interface ITableRow {
  subjectAreaDisplay: string; // course(diff).subjectArea or gapPlan.gradReq human
  courseDisplay: string; // course(diff).courseCode-section or gapPlan.plan
  courseDisplayTooltip: string; // course(diff).name or gapPlan.note
}
interface ICourseRow extends ICurrProgramCoursePartial, ITableRow {
  warningInfo: ICourseWarnings; // warningInfo for course
}
interface ICourseDiffRow extends ICourseDiffPartial, ICourseRow {
  statusDisplay: string; // 'PENDING ADD' or 'PENDING DROP'
  courseDiffId: string; // courseDiff._id
  courseDiffStatus: string; // courseDiff.status
  courseDiffAppliedAtHuman: string; // courseDiff.appliedAt human
}
interface IGapPlanRow extends IGapPlanPartial, ITableRow {
  period: null; // always null -- needed for sorting
  termDisplay: string; // courseDiff.term human
  termYear: number; // for sorting
  statusDisplay: string; // 'PENDING ADD'
  gapPlanId: string; // gapPlan._id
}
interface INetGapDetailsForAlignedGradReq {
  camelCase: string;
  human: string;
  netGaps: number;
}
interface ITermDetails {
  termType: 'CURRENT' | 'NEXT' | 'FUTURE';
  value: number;
  display: any;
}
type currentProgramTableRows = Array<ICourseRow | ICourseDiffRow | IGapPlanRow>;

const rowSortFeilds = ['period', 'termYear', 'subjectAreaDisplay'];

export class StudentCreditGapsPanelCurrentProgramCtrl {
  static $inject = [
    '$scope',
    'ImSchool',
    'ImStudentCreditGaps',
    'ImStudentCurrentProgram',
    'CourseDiff',
    'GapPlan',
    'UtilitiesService',
    'ErrorModal',
    'Rollbar',
    '$window',
    'CreditGapCoursePickerModal',
    'CreditGapFreeformCourseModal',
    'CreditGapConfirmDropModal',
    'ImGapPlan',
    'ImCourseDiff',
  ];

  constructor(
    private $scope,
    private ImSchool: ImSchool,
    private ImStudentCreditGaps: ImStudentCreditGaps,
    private ImStudentCurrentProgram: ImStudentCurrentProgram,
    private CourseDiff,
    private GapPlan,
    private UtilitiesService: UtilitiesService,
    private ErrorModal,
    private Rollbar,
    private $window,
    private coursePickerModal: CreditGapCoursePickerModal,
    private openEndedModal: CreditGapFreeformCourseModal,
    private CreditGapConfirmDropModal,
    private imGapPlan: ImGapPlan,
    private imCourseDiff: ImCourseDiff,
  ) {
    // set listeners on initialization
    this.$scope.$on('newCourseDiff', (evt, data) => {
      this.studentDiffs = [...this.studentDiffs, new CourseDiff(data)];
    });

    this.$scope.$on('updatedCourseDiff', (evt, data) => {
      const updatedCourseDiff = data.patches[0].patch;
      const indexToSwap = _.findIndex(this.studentDiffs, { _id: updatedCourseDiff._id });
      this.studentDiffs[indexToSwap] = new CourseDiff(updatedCourseDiff);
    });

    this.$scope.$on('newGapPlan', (evt, data) => {
      this.studentGapPlans = [...this.studentGapPlans, new GapPlan(data)];
    });

    this.$scope.$on('updatedGapPlan', (evt, data) => {
      const updatedGapPlan = data.patches[0].patch;
      const indexToSwap = _.findIndex(this.studentGapPlans, { _id: updatedGapPlan._id });
      this.studentGapPlans[indexToSwap] = new GapPlan(updatedGapPlan);
    });

    this.$scope.hover = function($event) {
      const tooltipEle = document.getElementsByClassName('nv-tooltip');
      if (tooltipEle.length === 1) {
        tooltipEle[0].setAttribute(
          'style',
          'position:fixed; top:' + ($event.y + 25) + 'px; left:' + ($event.x - 20) + 'px; max-width:250px;',
        );
      }
    };
  }

  // BINDINGS
  public school: ISchool;
  public student: IStudent;
  public studentDiffs: ICourseDiff[];
  public studentGapPlans: IGapPlan[];
  public isRestricted: boolean;

  public pendingAdds;
  public pendingDrops;
  public activeGapPlans: IGapPlan[];

  public currentProgramTableRows: currentProgramTableRows;
  public nextTermTableRows: IGapPlanRow[];
  public futureTermsTableRows: IGapPlanRow[];

  // for modals
  public termYearTypes = {
    CURRENT: {
      termType: 'CURRENT',
      value: null,
      display: null,
    } as ITermDetails,
    NEXT: {
      termType: 'NEXT',
      value: null,
      display: null,
    } as ITermDetails,
    FUTURE: {
      termType: 'FUTURE',
      value: null,
      display: null,
    } as ITermDetails,
  };

  $onInit() {
    this.setUi();
  }

  setUi(): void {
    this.setTermYearTypes();
    this.setPendingStudentDiffs();
    this.setActiveStudentGapPlans();
    this.setTables();

    // Set watcher to listen for changes to studentDiffs and update tables when changes are detected
    this.$scope.$watch(
      () => {
        return this.studentDiffs;
      },
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.setPendingStudentDiffs();
          this.setTables();
        }
      },
      true,
    );

    // Set watcher to listen for changes to studentGapPlans and update tables when changes are detected
    this.$scope.$watch(
      () => {
        return this.studentGapPlans;
      },
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.setActiveStudentGapPlans();
          this.setTables();
        }
      },
      true,
    );
  }

  openMenu = ($mdOpenMenu, ev) => {
    $mdOpenMenu(ev);
  };

  setTermYearTypes() {
    this.termYearTypes.CURRENT.value = this.ImSchool.getCurrentTermYear(this.school);
    this.termYearTypes.CURRENT.display = this.UtilitiesService.getHumanReadableTerm(this.termYearTypes.CURRENT.value);
    this.termYearTypes.NEXT.value = this.ImSchool.getNextTermYear(this.school);
    this.termYearTypes.NEXT.display = this.UtilitiesService.getHumanReadableTerm(this.termYearTypes.NEXT.value);
    this.termYearTypes.FUTURE.value = this.ImSchool.getNextTermYear(this.school, this.termYearTypes.NEXT.value);
    this.termYearTypes.FUTURE.display = this.UtilitiesService.getHumanReadableTerm(this.termYearTypes.FUTURE.value);
  }

  setPendingStudentDiffs() {
    const pendingStatusFilter = { status: 'PENDING' };
    this.pendingAdds = this.imCourseDiff.filterForAddCourseDiffs(this.studentDiffs, pendingStatusFilter);
    this.pendingDrops = this.imCourseDiff.filterForDropCourseDiffs(this.studentDiffs, pendingStatusFilter);
  }

  setActiveStudentGapPlans() {
    this.activeGapPlans = this.imGapPlan.filterForPendingFutureAndInvalid(
      this.studentGapPlans,
      this.termYearTypes.CURRENT.value,
    );
  }

  setTables() {
    this.currentProgramTableRows = this.getCurrentProgramTableRows();
    this.nextTermTableRows = this.getNextTermTableRows();
    this.futureTermsTableRows = this.getFutureTermsTableRows();
  }

  getCurrentProgramTableRows(): currentProgramTableRows {
    // Get the students program for the current term without the pending drops
    const currentProgramWithoutPendingDrops = this._getCurrentProgramWithoutPendingDrops();

    // Get pending drops for the current term in the correct format
    const pendingDropsForCurrentTerm = this._getPendingDiffsForTermYear(
      this.pendingDrops,
      this.termYearTypes.CURRENT.value,
    );

    // Get pending adds for the current term
    const pendingAddsForCurrentTerm = this._getPendingDiffsForTermYear(
      this.pendingAdds,
      this.termYearTypes.CURRENT.value,
    );

    // Get active gap plans for the current term
    const activeGapPlansForCurrentTerm = this._getActiveGapPlanForTermYear(this.termYearTypes.CURRENT.value);

    // Append everything into a single array
    const currentProgramWithPendingDropsAndPendingAddsAndActiveGapPlans: currentProgramTableRows = [
      ...currentProgramWithoutPendingDrops,
      ...pendingDropsForCurrentTerm,
      ...pendingAddsForCurrentTerm,
      ...activeGapPlansForCurrentTerm,
    ];

    // Sort rows
    const sortedRows = _.sortBy(currentProgramWithPendingDropsAndPendingAddsAndActiveGapPlans, rowSortFeilds);

    return sortedRows;
  }

  getNextTermTableRows(): IGapPlanRow[] {
    const activeGapPlansForNextTerm = this._getActiveGapPlanForTermYear(this.termYearTypes.NEXT.value);
    const sortedRows = _.sortBy(activeGapPlansForNextTerm, rowSortFeilds);
    return sortedRows;
  }

  getFutureTermsTableRows(): IGapPlanRow[] {
    const filterForFuture = true;
    const activeGapPlansForFutureTerms = this._getActiveGapPlanForTermYear(
      this.termYearTypes.NEXT.value,
      filterForFuture,
    );
    const sortedRows = _.sortBy(activeGapPlansForFutureTerms, rowSortFeilds);
    return sortedRows;
  }

  // TABLE HELPERS

  _getCurrentProgramWithoutPendingDrops(): ICourseRow[] {
    const currentProgramWithoutPendingDrops = this.ImStudentCreditGaps.getCoursesForCurrentTermYearWithoutDropCourseDiffs(
      this.student,
      this.pendingDrops,
    );
    const formattedCurrentProgramWithoutPendingDrops = _.map(currentProgramWithoutPendingDrops, course => {
      return this._getCourseInfoFromCurrProgram(course);
    });
    return formattedCurrentProgramWithoutPendingDrops;
  }

  _getPendingDiffsForTermYear(pendingDiffs: ICourseDiff[], termYear: number): ICourseDiffRow[] {
    const pendingDiffsForTermYear = _.filter(pendingDiffs, { termYear });
    const formattedDiffs = _.reduce(
      pendingDiffsForTermYear,
      (result, pendingDiff) => {
        const formattedDiff = this._formatDiff(pendingDiff);
        if (formattedDiff) result.push(formattedDiff);
        return result;
      },
      [],
    );
    return formattedDiffs;
  }

  _getActiveGapPlanForTermYear(termYear: number, filterForFuture?: boolean): IGapPlanRow[] {
    let activeGapPlansForTermYear;
    if (!filterForFuture) {
      activeGapPlansForTermYear = _.filter(this.activeGapPlans, { termYear });
    } else {
      activeGapPlansForTermYear = _.filter(this.activeGapPlans, (activeGapPlan: IGapPlan) => {
        return activeGapPlan.termYear > termYear;
      });
    }
    const formattedGapPlans = _.map(activeGapPlansForTermYear, (activeGapPlan: IGapPlan) => {
      return this._formatGapPlan(activeGapPlan);
    });
    return formattedGapPlans;
  }

  _getCourseInfoFromCurrProgram(course: ICurrProgramCourse): ICourseRow {
    const subjectAreaHuman = this._getHumanReadableSubjectAreaForCourse(course);
    // DS TODO: this doesn't need to be on ImStudentCreditGaps model
    course = this.ImStudentCreditGaps.appendCycleDayToCourse(this.student, this.school, course);
    const warningInfo = this.ImStudentCurrentProgram.getCurrSyCourseWarningInfo(this.student, course);

    return {
      subjectAreaDisplay: subjectAreaHuman,
      courseDisplay: `${course.courseCode}-${course.section}`,
      courseDisplayTooltip: course.courseName,
      gradReq: course.gradReq,
      period: course.period,
      courseCode: course.courseCode,
      cycleDay: course.cycleDay,
      cyclePeriod: course.cyclePeriod,
      creditValue: course.creditValue,
      courseId: course.courseId, // used for drop action
      warningInfo, // used for warning icon and tooltip
    };
  }

  _getCourseInfoFromMasterSchedule(course: ICourse): ICourseRow {
    const subjectAreaHuman = this._getHumanReadableSubjectAreaForCourse(course);

    return {
      subjectAreaDisplay: subjectAreaHuman || null,
      courseDisplay: `${course.courseCode}-${course.section}`,
      courseDisplayTooltip: course.courseName,
      gradReq: course.gradReq,
      period: course.period,
      courseCode: course.courseCode,
      cycleDay: course.cycleDay,
      cyclePeriod: course.cyclePeriod,
      creditValue: course.creditValue,
      courseId: course.courseId,
      warningInfo: undefined,
    };
  }

  _getHumanReadableSubjectAreaForCourse(course: ICourse | ICurrProgramCourse): string {
    const subjectAreaHuman = ImStudentCurrentProgramHelpers.getHumanReadableSubjectAreaForCourse(course);
    if (!_.isNull(course.subjectArea) && !subjectAreaHuman) {
      this.Rollbar.warning(`${course.subjectArea} is missing from SubjectAreas constant`);
    }
    return subjectAreaHuman;
  }

  _formatDiff(courseDiff: ICourseDiff): ICourseDiffRow {
    let formattedDiff;

    // Get the course details of the course on the courseDiff
    // First check the students current program, then check the school master schedule
    let courseInfo;
    const { courseId } = courseDiff;
    const { currSy } = this.student.studentProgramDetails;

    const correspondingCourseFromStudent: ICurrProgramCourse = _.find(currSy, { courseId });

    if (correspondingCourseFromStudent) {
      courseInfo = this._getCourseInfoFromCurrProgram(correspondingCourseFromStudent);
    } else {
      const correspondingCourseFromMaster: ICourse = this.ImSchool.getCourseByIdFromMasterSchedule(
        this.school,
        courseId,
      );

      if (!correspondingCourseFromMaster) {
        this.Rollbar.warning(`
          CourseDiff with ID ${courseDiff._id} has courseId ${courseId} that
          cannot be found on current program or master schedule
        `);
        courseInfo = null;
      } else {
        courseInfo = this._getCourseInfoFromMasterSchedule(correspondingCourseFromMaster);
      }
    }

    // Add courseDiff._id to course to correctly identify courseDiff to be 'DELETED' when 'UNDO' is clicked
    // Add courseDiff.statusDisplay to course to correctly show if it is an ADD or DROP
    if (courseInfo) {
      const courseDiffAppliedAtHuman = this.UtilitiesService.convertISODateToHumanDate(courseDiff.appliedAt);
      formattedDiff = _.assign(
        {
          courseDiffId: courseDiff._id,
          courseDiffStatus: courseDiff.status,
          courseDiffAppliedAtHuman,
          statusDisplay: 'PENDING ' + courseDiff.action,
        },
        courseInfo,
      );
    }
    return formattedDiff;
  }

  _formatGapPlan(activeGapPlan: IGapPlan): IGapPlanRow {
    const humanReadableGradReq = this.UtilitiesService.getHumanReadableGradReq(activeGapPlan.gradReq);
    const humanReadableTerm = this.UtilitiesService.getHumanReadableTerm(activeGapPlan.termYear);
    const isInvalid = this.imGapPlan.isActiveAndInvalid(activeGapPlan, activeGapPlan.termYear);
    return {
      gapPlanId: activeGapPlan._id,
      subjectAreaDisplay: humanReadableGradReq,
      courseDisplay: activeGapPlan.plan || activeGapPlan.note,
      courseDisplayTooltip: activeGapPlan.plan && activeGapPlan.note,
      creditValue: activeGapPlan.creditValue,
      statusDisplay: isInvalid ? 'INVALID' : 'PENDING ADD',
      termDisplay: humanReadableTerm,
      termYear: activeGapPlan.termYear, // for sorting
      period: null,
    };
  }

  // DIFF ACTIONS

  createDropCourseDiff(courseId: string, gradReq: string, courseName: string, creditValue: number) {
    const create = () => {
      return this._createCourseDiff({ courseId, action: 'DROP' })
        .then(savedCourseDiff => {
          this.studentDiffs.push(savedCourseDiff);
        })
        .catch(error => {
          this.ErrorModal.show('Error', error);
        });
    };
    const alignedGradReqsWithGapsIfDropped = this._getAlignedGradReqsWithGapsIfDropped(gradReq, creditValue);

    if (creditValue && alignedGradReqsWithGapsIfDropped.length) {
      return this.CreditGapConfirmDropModal.show(courseName, alignedGradReqsWithGapsIfDropped, creditValue)
        .then(() => {
          return create();
        })
        .catch(err => {
          // When "cancel" button is clicked, err will be undefined (JC)
          if (!err) return;
          this.Rollbar.error(`Unable to create course diff for dropping a gap plan`, err);
        });
    }

    return create();
  }

  _getAlignedGradReqsWithGapsIfDropped(gradReq: string, creditValue: number): INetGapDetailsForAlignedGradReq[] {
    // get all the net gaps for the aligned grad reqs
    const netGapsForAlignedGradReqs: INetGapDetailsForAlignedGradReq[] = this.ImStudentCreditGaps.getNetGapsForAlignedGradReqs(
      this.student,
      this.studentDiffs,
      this.studentGapPlans,
      this.school,
      gradReq,
    );
    // subtract the credit value of the drop from the net gaps
    // this is the NEW net gap if the drop is applied
    const netGapsForAlignedGradReqsIfDropped = _.map(_.cloneDeep(netGapsForAlignedGradReqs), item => {
      item.netGaps -= creditValue;
      return item;
    });
    // filter the aligned grad reqs for just the ones where the NEW net gap would be less than 0 if the drop is applied
    const alignedGradReqsWithGapsIfDropped = _.reduce(
      netGapsForAlignedGradReqsIfDropped,
      (result, item) => {
        if (item.netGaps < 0) {
          result.push(item);
        }
        return result;
      },
      [],
    );
    return alignedGradReqsWithGapsIfDropped;
  }

  _createCourseDiff({ courseId, action }) {
    if (!courseId || !action) {
      throw new Error('Missing required "courseId" or "action" parameter');
    }

    const _id = this.UtilitiesService.createV4Uuid();
    const schoolId = this.school._id;
    const studentId = this.student._id;
    const lastFirst = this.student.studentDetails.name.lastFirst;
    const termYear = this.termYearTypes.CURRENT.value;
    const newCourseDiff: any = this._createCourseDiffFromTemplate({
      _id,
      schoolId,
      studentId,
      lastFirst,
      termYear,
      courseId,
      action,
    });

    return newCourseDiff.$create();
  }

  _createCourseDiffFromTemplate({ _id, schoolId, studentId, lastFirst, termYear, courseId, action }): ICourseDiff {
    return new this.CourseDiff({
      _id,
      schoolId,
      student: {
        studentId,
        lastFirst,
      },
      termYear,
      courseId,
      action,
    });
  }

  undoCourseDiff(courseDiffId: string) {
    let undoneCourseDiff: any = _.remove(this.studentDiffs, { _id: courseDiffId })[0];
    if (undoneCourseDiff) {
      undoneCourseDiff = this._updateInstanceWithDeletedStatus(undoneCourseDiff);
      undoneCourseDiff.$patchFields(['status']);
    }
  }

  // GAP PLAN ACTIONS

  undoGapPlan(gapPlanId: string) {
    let undoneGapPlan: any = _.remove(this.studentGapPlans, { _id: gapPlanId })[0];
    if (undoneGapPlan) {
      undoneGapPlan = this._updateInstanceWithDeletedStatus(undoneGapPlan);
      undoneGapPlan.$patchFields(['status']);
    }
  }

  _updateInstanceWithDeletedStatus(instance: ICourseDiff | IGapPlan) {
    instance.status = 'DELETED';
    return instance;
  }

  // OPENS MODALS

  editGapPlan(termDetails: ITermDetails, gapPlanId: string) {
    const gapPlan = _.find(this.studentGapPlans, { _id: gapPlanId });
    termDetails = _.clone(termDetails);
    termDetails.value = gapPlan.termYear;
    this.openFreeFormCoursePickerModal(termDetails, gapPlan);
  }

  openCoursePickerModal(termDetails: ITermDetails) {
    this.coursePickerModal.show(this.studentDiffs, this.studentGapPlans, termDetails, this.school, this.student);
  }

  openFreeFormCoursePickerModal(termDetails: ITermDetails, gapPlan?) {
    this.openEndedModal.show(
      termDetails,
      this.student,
      this.school,
      // TODO: remove studentGapPlans once this panel is hooked up to Store.
      // The modal currently pushes the new gap plan onto the students array of gapPlans,
      // but it also updates the store (JC).
      this.studentGapPlans,
      gapPlan,
    );
  }
}
